/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {


  async fetchTotalLeaseOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/leaseOrder/getTotalLeaseOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_LEASE_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },

  async fetchLeaseOrder({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/leaseOrder/getLeaseOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_LEASE_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewLeaseOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/leaseOrder/save`, payload.order)
      payload.order.idLeaseOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_LEASE_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/locacao`).catch(() => { });
  },



  async removeLeaseOrder({ commit }, payload) {
    let idLeaseOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/leaseOrder/remove`, { idLeaseOrder })
      payload.loading.close()
      commit('REMOVE_LEASE_ORDER', idLeaseOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso", 
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateLeaseOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/leaseOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_LEASE_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/locacao`).catch(err => { });
  },

  async trashLeaseOrder({ commit }, payload) {
    let idLeaseOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/leaseOrder/trash`,{ idLeaseOrder }
      )
      payload.loading.close()
      commit('REMOVE_LEASE_ORDER', idLeaseOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },
}
